import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "../../../design-system";
import logoSite from "../../../../assets/brand/logo_site.svg";
import { ROUTES } from "../../../../constants";
import TopBarAvatar from "./TopBar/TopBarAvatar";

/**
 * Clean top navigation for the no-sidebar home-page layout variants (B–F). Replaces the
 * distracting 260px sidebar with the pattern the conversion teacher's liked sites use:
 * logo left, a couple of links, a primary action + account on the right. The 3 old sidebar
 * destinations live here now (Home = the logo; My Videos; Learning Center).
 */
const LEARNING_CENTER_URL =
  "https://www.youtube.com/playlist?list=PLCmEY2bUooBzva-gvuh3TpOpWoHjuRMqm";

const HomeTopNav: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: "64px",
        zIndex: 11000,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: "16px", md: "32px" },
        fontFamily: "Outfit, sans-serif",
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(12,11,16,0.55)",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
      }}
    >
      {/* Logo = Home */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "9px", cursor: "pointer" }} onClick={() => navigate(ROUTES.HOME)}>
        <img src={logoSite} alt="CherryClipz" width={28} style={{ display: "block", height: "auto" }} />
        <Typography sx={{ fontFamily: "Outfit, sans-serif", fontWeight: 800, color: "#fff", fontSize: "18px", letterSpacing: "-0.01em" }}>
          Cherry<Box component="span" sx={{ color: "#e61d50" }}>Clipz</Box>
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: { xs: "12px", md: "24px" } }}>
        <Typography
          onClick={() => navigate(ROUTES.MY_LIBRARY)}
          sx={{ display: { xs: "none", sm: "block" }, cursor: "pointer", fontFamily: "Outfit, sans-serif", color: "#c2c7d6", fontWeight: 500, fontSize: "15px", "&:hover": { color: "#fff" } }}
        >
          My Videos
        </Typography>
        <Typography
          onClick={() => window.open(LEARNING_CENTER_URL, "_blank", "noopener,noreferrer")}
          sx={{ display: { xs: "none", sm: "block" }, cursor: "pointer", fontFamily: "Outfit, sans-serif", color: "#c2c7d6", fontWeight: 500, fontSize: "15px", "&:hover": { color: "#fff" } }}
        >
          Learning Center
        </Typography>
        <Box
          component="button"
          onClick={() => navigate(ROUTES.HOME)}
          sx={{ cursor: "pointer", border: "none", borderRadius: "999px", backgroundColor: "#e61d50", color: "#fff", fontWeight: 700, fontFamily: "Outfit, sans-serif", fontSize: "14px", padding: "8px 18px", "&:hover": { backgroundColor: "#c4123f" } }}
        >
          Upload
        </Box>
        <TopBarAvatar onClick={() => navigate(ROUTES.MY_LIBRARY)} />
      </Box>
    </Box>
  );
};

export default HomeTopNav;
